var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgInstagram = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 20,
    height: 20,
    rx: 4.8,
    stroke: "#7D86A1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9566 10.4133C15.2097 12.1202 14.3396 13.797 12.7983 14.5728C11.2569 15.3486 9.3918 15.0485 8.17164 13.8284C6.95147 12.6082 6.65135 10.7431 7.42715 9.20174C8.20295 7.6604 9.87977 6.79034 11.5867 7.04345C13.3296 7.3019 14.6981 8.67041 14.9566 10.4133Z",
    stroke: "#7D86A1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6C17.3284 6 18 5.32843 18 4.5C18 3.67157 17.3284 3 16.5 3C15.6716 3 15 3.67157 15 4.5C15 5.32843 15.6716 6 16.5 6Z",
    fill: "#7D86A1",
    stroke: "#F5F7FA",
    strokeWidth: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInstagram, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/instagram.0a6fc256.svg";
export { ForwardRef as ReactComponent };